import "./Navbar.css";
import { useState } from "react";
import RLDLogo from "../../images/Logo/RLD v1.svg";
import { Link, animateScroll as scroll } from "react-scroll";

const navLinks = [
  { to: "services", label: "Services" },
  { to: "contact", label: "Contact" },
];

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const handleNavClick = () => {
    closeMenu();
  };

  return (
    <header className="fixed top-0 z-50 w-full border-b border-rld-border/50 bg-rld-black/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <button
          onClick={() => {
            closeMenu();
            scroll.scrollToTop();
          }}
          className="transition-opacity hover:opacity-70"
          aria-label="Scroll to top"
        >
          <img
            src={RLDLogo}
            alt="Rare Life Design"
            className="h-7 w-auto brightness-0 invert md:h-8"
          />
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map(({ to, label }) => (
            <div key={to} className="navButton flex flex-col items-center">
              <Link
                to={to}
                spy={true}
                smooth={true}
                offset={-64}
                duration={500}
                activeClass="nav-link-active"
                className="font-mono text-sm uppercase tracking-widest text-rld-muted transition-colors hover:text-rld-white"
              >
                {label}
              </Link>
              <div className="nav-line mt-1 h-px w-full bg-rld-border transition-colors" />
            </div>
          ))}
        </nav>

        <button
          className="flex flex-col justify-center gap-1.5 p-2 md:hidden"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
          aria-expanded={menuOpen}
        >
          <span
            className={`block h-px w-6 bg-rld-white transition-all duration-300 ${
              menuOpen ? "translate-y-[7px] rotate-45" : ""
            }`}
          />
          <span
            className={`block h-px w-6 bg-rld-white transition-all duration-300 ${
              menuOpen ? "opacity-0" : ""
            }`}
          />
          <span
            className={`block h-px w-6 bg-rld-white transition-all duration-300 ${
              menuOpen ? "-translate-y-[7px] -rotate-45" : ""
            }`}
          />
        </button>
      </div>

      <div
        className={`overflow-hidden border-t border-rld-border/50 bg-rld-black transition-all duration-300 md:hidden ${
          menuOpen ? "max-h-48 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="flex flex-col px-6 py-4">
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              spy={true}
              smooth={true}
              offset={-64}
              duration={500}
              activeClass="mobile-nav-link-active"
              onClick={handleNavClick}
              className="border-b border-rld-border py-4 font-mono text-sm uppercase tracking-widest text-rld-muted transition-colors last:border-0 hover:text-rld-white"
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
